// operations/mongo.ts
import { map, of } from "rxjs";
import { Int } from "../baseqlTypes.js";
import { MongoEntity } from "../entities/mongoEntity.js";
import { registerMutation, registerQuery, registerSubscription } from "../metadata/register.js";
import {
  countAllEntitiesResolver,
  createEntityResolver,
  findEntityByTextResolver,
  getAllEntitiesResolver,
  getEntityByIDResolver,
  removeEntityResolver,
  subscribeAllEntitiesResolver,
  subscribeEntityByIDResolver,
  subscribeEntityCountResolver,
  updateEntityResolver
} from "../server/resolver/mongo.js";
var getEntityByIDOp = registerQuery({
  type: () => [MongoEntity],
  operationName: "getEntityByID",
  resolve: getEntityByIDResolver,
  params: [
    { type: () => String, name: "entityClass" },
    { type: () => [String], name: "ids" }
  ]
});
var getEntityByID = (entity, ids) => getEntityByIDOp(entity._class, ids);
var getAllEntitiesOp = registerQuery({
  type: () => [MongoEntity],
  operationName: "getAllEntities",
  resolve: getAllEntitiesResolver,
  params: [
    { type: () => String, name: "entityClass" },
    { type: () => Int, name: "skip" },
    { type: () => Int, name: "limit" },
    { type: () => [String], name: "excludeIDs" }
  ]
});
var getAllEntities = (entity, skip, limit, excludeIDs) => getAllEntitiesOp(entity._class, skip, limit, excludeIDs);
var countAllEntitiesOp = registerQuery({
  type: () => Int,
  operationName: "countAllEntities",
  resolve: countAllEntitiesResolver,
  params: [{ type: () => String, name: "entityClass" }]
});
var countAllEntities = (entity) => countAllEntitiesOp(entity._class);
var findEntityByTextOp = registerQuery({
  type: () => [MongoEntity],
  operationName: "findEntityByText",
  resolve: findEntityByTextResolver,
  params: [
    { type: () => String, name: "entityClass" },
    { type: () => [String], name: "searchfields" },
    { type: () => String, name: "searchText" },
    { type: () => String, name: "regexOptions" }
  ]
});
var findEntityByText = (entity, searchFields, searchText, regexOptions) => findEntityByTextOp(entity._class, searchFields, searchText, regexOptions);
var subscribeEntityByIDOp = registerSubscription({
  type: () => [MongoEntity],
  operationName: "subscribeEntityByID",
  resolve: subscribeEntityByIDResolver,
  params: [
    { type: () => String, name: "entityClass" },
    { type: () => [String], name: "ids" }
  ]
});
var subscribeEntityByID = (entity, ids) => subscribeEntityByIDOp(entity._class, ids);
var subscribeAllEntitiesOp = registerSubscription({
  type: () => [MongoEntity],
  operationName: "subscribeAllEntities",
  resolve: subscribeAllEntitiesResolver,
  params: [
    { type: () => String, name: "entityClass" },
    { type: () => Int, name: "skip" },
    { type: () => Int, name: "limit" },
    { type: () => [String], name: "excludeIDs" }
  ]
});
var subscribeAllEntities = (entity, skip, limit, excludeIDs) => subscribeAllEntitiesOp(entity._class, skip, limit, excludeIDs);
var subscribeEntityCountOp = registerSubscription({
  type: () => Int,
  operationName: "subscribeEntityCount",
  resolve: subscribeEntityCountResolver,
  params: [
    { type: () => String, name: "entityClass" },
    { type: () => [String], name: "excludeIDs" }
  ]
});
var subscribeEntityCount = (entity, excludeIDs) => subscribeEntityCountOp(entity._class, excludeIDs);
var updateEntity = registerMutation({
  type: () => Int,
  operationName: "updateEntity",
  resolve: updateEntityResolver,
  params: [{ type: () => MongoEntity, name: "entity" }]
});
var createEntity = registerMutation({
  type: () => String,
  operationName: "createEntity",
  resolve: createEntityResolver,
  params: [{ type: () => MongoEntity, name: "entity" }]
});
var removeEntityOp = registerMutation({
  type: () => Int,
  operationName: "removeEntity",
  resolve: removeEntityResolver,
  params: [
    { type: () => String, name: "entityClass" },
    { type: () => String, name: "id" }
  ]
});
var removeEntity = (entity, id) => removeEntityOp(entity._class, id);
function getByID(entity, id) {
  return async (gqlFields) => {
    let isArray = true;
    if (!id)
      return null;
    if (!Array.isArray(id)) {
      id = [id];
      isArray = false;
    } else if (!id.length)
      return [];
    const result = await getEntityByIDOp(entity._class, id)(gqlFields);
    if (isArray)
      return result;
    return result[0] ?? null;
  };
}
function subscribeByID(entity, id) {
  return (gqlFields) => {
    let isArray = true;
    if (!id)
      return of(null);
    if (!Array.isArray(id)) {
      id = [id];
      isArray = false;
    } else if (!id.length)
      return of([]);
    return subscribeEntityByID(
      entity,
      id
    )(gqlFields).pipe(
      map((result) => {
        if (isArray)
          return result;
        return result[0] ?? null;
      })
    );
  };
}
export {
  countAllEntities,
  createEntity,
  findEntityByText,
  getAllEntities,
  getAllEntitiesOp,
  getByID,
  getEntityByID,
  removeEntity,
  subscribeAllEntities,
  subscribeByID,
  subscribeEntityByID,
  subscribeEntityCount,
  updateEntity
};
